import type {
  ParticipantDisplayRole,
  ParticipantRole,
  Participant as ParticipantType,
} from "@/react/types/Live/Participant";
import { ParticipantAvatar } from "@circle-react/components/LiveStreams/Room/ParticipantAvatar";
import { PARTICIPANT_DISPLAY_ROLES as ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import { RoleIcon } from "./RoleIcon";

interface ParticipantProps {
  host: ParticipantType | undefined;
  participant: ParticipantType;
}

export const Participant = ({ participant, host }: ParticipantProps) => {
  if (!participant) return null;

  const { name, avatar_url: avatarUrl, id } = participant;
  let { role } = participant;

  if (role === ROLES.HOST && host?.id !== id) {
    role = ROLES.COHOST as ParticipantRole;
  }

  return (
    <div className="mx-3 flex items-center justify-start rounded-md px-3 py-2">
      <div className="relative mr-4 h-10 w-10">
        <ParticipantAvatar name={name} src={avatarUrl} size="sm" />
      </div>
      <div className="text-darkest mr-2 truncate font-medium">
        {name}
        {Boolean(role) && <RoleIcon role={role as ParticipantDisplayRole} />}
      </div>
    </div>
  );
};
